export default "__VITE_ASSET__DLOGwCDk__"